import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './steps/Steps.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:10000';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [payment, setPayment] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get('session_id');

      if (!sessionId) {
        setError('No session ID found');
        setVerifying(false);
        return;
      }

      try {
        // Verify payment with backend
        const response = await axios.get(
          `${API_URL}/api/payment/verify/${sessionId}`
        );

        setPayment(response.data);
        setVerifying(false);

        // After 3 seconds, redirect to wizard to continue with video generation
        setTimeout(() => {
          navigate(`/app/create/${response.data.daycareId}?session_id=${sessionId}`);
        }, 3000);
      } catch (err) {
        console.error('Error verifying payment:', err);
        setError('Failed to verify payment');
        setVerifying(false);
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  if (verifying) {
    return (
      <div className="payment-result-container">
        <div className="payment-result-card">
          <div className="spinner-large"></div>
          <h2>Verifying Payment...</h2>
          <p>Please wait while we confirm your payment</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-result-container">
        <div className="payment-result-card error">
          <div className="result-icon">❌</div>
          <h2>Payment Verification Failed</h2>
          <p>{error}</p>
          <button
            className="btn-primary"
            onClick={() => navigate('/')}
          >
            Return Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-result-container">
      <div className="payment-result-card success">
        <div className="result-icon">✅</div>
        <h2>Payment Successful!</h2>
        <p>Thank you for your purchase</p>

        {payment && (
          <div className="payment-details">
            <div className="detail-row">
              <span className="detail-label">Package:</span>
              <span className="detail-value">
                {payment.productType === 'single_video' && 'Single Video'}
                {payment.productType === 'video_3pack' && '3-Video Pack'}
                {payment.productType === 'video_10pack' && '10-Video Pack'}
              </span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Credits:</span>
              <span className="detail-value">{payment.videosRemaining} videos</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Amount:</span>
              <span className="detail-value">${(payment.amount / 100).toFixed(2)}</span>
            </div>
          </div>
        )}

        <div className="success-message">
          <p>Redirecting you to create your video...</p>
          <div className="spinner-small"></div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
